import { render, staticRenderFns } from "./ActivateWeldingInspectors.vue?vue&type=template&id=2a0f0dfc"
import script from "./ActivateWeldingInspectors.vue?vue&type=script&lang=js"
export * from "./ActivateWeldingInspectors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports